import { useNavigate } from "react-router-dom";
import { classNames } from "shared/lib/classNames/classNames";
import { useDispatch, useSelector } from "react-redux";
import { useApi } from "app/api/APIProvider";
import { Button, ButtonTheme } from "shared/ui/Button/Button";
import { AppLink, AppLinkTheme } from "shared/ui/AppLink/AppLink";
import { getPlotStepData, plotStepsActions } from "widgets/PlotSteps";
import { plotStepData } from "widgets/PlotSteps/model/api/stepData";
import { useEffect, useState } from "react";
import { string } from "yup";
import { all } from "axios";
import cls from "./Buttons.module.scss";

interface ButtonsProps {
    className?: string;
}

function randomInteger(min: number, max: number) {
    return Math.floor(Math.random() * (max - min) + min);
}
export const Buttons = (props: ButtonsProps) => {
    const { className } = props;
    const dispatch = useDispatch();
    const stepData = useSelector(getPlotStepData);
    const api = useApi();
    const navigate = useNavigate();
    const user = api.User;
    const prevStep = user?.current_scene?.previousStep;
    const currentStep = user?.current_scene?.plotStep;
    const [isDisabledButton, setIsDisabledButton] = useState<boolean>(false);

    const changeStep = async (
        e: any,
        button: any,
        isFinalStep: boolean,
        plotOptions?: any
    ) => {
        e.preventDefault();

        console.log(button, "button");

        return api
            .EditUser({
                current_scene: {
                    plotStep: button.linkOnStep,
                    previousStep: currentStep,
                },
                level: isFinalStep ? user.level + 1 : user.level,
            })
            .then(() => {
                user.current_scene = {
                    plotStep: button.linkOnStep,
                    previousStep: currentStep,
                };

                if (button.externalLink) {
                    window.location.href = button.linkOnPage;
                } else if (button.linkOnPage) {
                    setTimeout(() => {
                        dispatch(
                            plotStepsActions.addedPlotStepData(
                                plotStepData(
                                    button.linkOnStep,
                                    user,
                                    plotOptions
                                )
                            )
                        );
                    }, 500);
                    navigate(button.linkOnPage);
                } else {
                    dispatch(
                        plotStepsActions.addedPlotStepData(
                            plotStepData(button.linkOnStep, user, plotOptions)
                        )
                    );
                }
                setIsDisabledButton(false);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const getFinalSum = async (
        e?: any,
        button?: any,
        isOnChangeStep?: boolean
    ) => {
        const { outcome, income, result } = await api.getFinalSum();
        sessionStorage.setItem("outcomeSum", outcome);
        sessionStorage.setItem("incomeSum", income);
        // sessionStorage.setItem('result', result);
        if (button.linkOnStep === 133) {
            await api.CancelAll();
        }
        const { wallet } = await api.GetAllSum();
        sessionStorage.setItem("result", String(wallet));
        const plotOptions = {
            wallet,
        };
        await changeStep(e, button, stepData.isFinalDisplay, plotOptions);
        sessionStorage.removeItem("credit");
    };

    const getSalary = async (
        e?: any,
        button?: any,
        isOnChangeStep?: boolean
    ) => {
        const user = await api.GetUser();
        const money = await api.GetAllSum();

        const plotOptions = {
            salary: user.salary_month,
            wallet: money.wallet,
        };
        if (isOnChangeStep) {
            await changeStep(e, button, stepData.isFinalDisplay, plotOptions);
        } else {
            // Обновление цифр в сообщении
            dispatch(
                plotStepsActions.addedPlotStepData(
                    plotStepData(user.current_scene.plotStep, user, plotOptions)
                )
            );
        }
    };

    const getAllMoney = async (
        e?: any,
        button?: any,
        isOnChangeStep?: boolean
    ) => {
        const money = await api.GetAllSum();
        const plotOptions = {
            wallet: money.wallet,
        };
        if (isOnChangeStep) {
            await changeStep(e, button, stepData.isFinalDisplay, plotOptions);
        } else {
            // Обновление цифр в сообщении
            dispatch(
                plotStepsActions.addedPlotStepData(
                    plotStepData(user.current_scene.plotStep, user, plotOptions)
                )
            );
        }
    };

    const getRandomInsuranceCase = async (
        e?: any,
        button?: any,
        isOnChangeStep?: boolean
    ) => {
        e.preventDefault();

        const finance = await api.GetFinanceInfo();
        const haveNsj = finance.nsj.status;
        const haveDsj = finance.dsj.status && user.level === 4;
        let allEvents: any = [];

        if (haveNsj && haveDsj) {
            allEvents = stepData?.eventsNsjDsj;
        } else if (haveNsj) {
            allEvents = stepData?.eventsNsj;
            console.log(allEvents, "haveNSJ");
        } else if (haveDsj) {
            allEvents = stepData?.eventsDsj;
        } else {
            allEvents = stepData.events;
        }
        // const allEvents = haveNsj ? stepData.eventsNsj : stepData.events;
        const eventNumber = randomInteger(1, Object.keys(allEvents).length);
        const newButton: any = {
            linkOnStep: allEvents[eventNumber].stepNumber,
        };
        ("earnedAll");

        if (haveNsj) {
            if (eventNumber === 4 || eventNumber === 5) {
                await api.Transaction({
                    name: "Оплата по договору НСЖ",
                    value: 500000,
                    to: "wallet",
                    ignore: 1,
                });
                await api.CancelFinance({
                    productKey: "nsj",
                });
            }
        }

        if (button.type === "link") {
            newButton.externalLink = button.externalLink;
            newButton.linkOnPage = button.linkOnPage;
            newButton.type = "link";
        }

        await changeStep(e, newButton, stepData.isFinalDisplay);
    };

    const setUseInsurance = async (
        e?: any,
        button?: any,
        isOnChangeStep?: boolean
    ) => {
        await api.UseFinance({
            productKey: stepData.insuranceKey,
        });

        await changeStep(e, button, stepData.isFinalDisplay);
    };

    const setTransaction = async (
        e?: any,
        button?: any,
        isOnChangeStep?: boolean
    ) => {
        await api.Transaction(stepData.transaction);

        if (isOnChangeStep) {
            await changeStep(e, button, stepData.isFinalDisplay);
        }
    };

    const setInsuranceCase = async (
        e?: any,
        button?: any,
        isOnChangeStep?: boolean
    ) => {
        await api.Transaction(stepData.transaction);
        const plotOptions = {
            policyName: stepData.checkPolicyData.policyName,
            transaction: stepData.checkPolicyData.transaction,
            dialogText: stepData.checkPolicyData.dialogText,
        };

        await changeStep(e, button, stepData.isFinalDisplay, plotOptions);
    };

    const checkPolicy = async (
        e?: any,
        button?: any,
        isOnChangeStep?: boolean
    ) => {
        const finance = await api.GetFinanceInfo();
        const requiredPolicy: ["dsj", "nsj"] = stepData.policyName;
        const intersection = requiredPolicy.filter(
            (element) => finance[element].status
        );
        // const intersection = ['dsj'];
        const newButton: any = {};

        if (intersection.length > 0) {
            await api.Transaction(stepData.transaction);
            newButton.linkOnStep = stepData.hasPolicyButton;
            getAllMoney(e, newButton, true);
        } else {
            newButton.linkOnStep = stepData.noPolicyButton;
            await changeStep(e, newButton, stepData.isFinalDisplay);
        }
    };

    const setMonthPassed = async (
        e?: any,
        button?: any,
        isOnChangeStep?: boolean
    ) => {
        const month = await api.PayMonth();
        await api.Transaction(stepData.transaction);

        const plotOptions = {
            monthIncome: month.result,
        };

        if (isOnChangeStep) {
            await changeStep(e, button, stepData.isFinalDisplay, plotOptions);
        }
    };

    const showOverlay = async (
        e?: any,
        button?: any,
        isOnChangeStep?: boolean,
        name?: string
    ) => {
        e.preventDefault();
        sessionStorage.setItem(name, "Показать");
        if (isOnChangeStep) {
            await changeStep(e, button, stepData.isFinalDisplay);
        }
    };

    const deleteAllMoney = async (
        e?: any,
        button?: any,
        isOnChangeStep?: boolean
    ) => {
        await api.DoScam({
            amount: 0,
        });
        if (isOnChangeStep) {
            await changeStep(e, button, stepData.isFinalDisplay);
        }
    };

    useEffect(() => {
        if (prevStep) {
            const previousStepData = plotStepData(prevStep, user);

            switch (true) {
                case previousStepData.needSalary:
                    getSalary();
                    break;
                case previousStepData.needAllMoney:
                    getAllMoney();
                    break;
                default:
                    console.log("___");
            }
        }
    }, []);

    return (
        <div
            className={classNames(
                cls.Buttons,
                { [cls.moneyViewButtonWrapper]: stepData.isMoneyViewButton },
                [className]
            )}
        >
            {stepData?.action?.buttons?.map((button: any) => {
                if (button.type === "link") {
                    return (
                        <AppLink
                            key={button.buttonText}
                            to={button.linkOnPage}
                            theme={AppLinkTheme.NEXT}
                            disabled={isDisabledButton}
                            className={classNames(
                                `${cls.backButton} ${cls.mb12}`,
                                {
                                    [cls.moneyViewButton]:
                                        stepData.isMoneyViewButton,
                                }
                            )}
                            onClick={(e) => {
                                setIsDisabledButton(true);
                                switch (true) {
                                    case stepData.showFinancialSection:
                                        showOverlay(
                                            e,
                                            button,
                                            true,
                                            "showFinancialSection"
                                        );
                                        break;
                                    case stepData.showShopSection:
                                        showOverlay(
                                            e,
                                            button,
                                            true,
                                            "showShopSection"
                                        );
                                        break;
                                    case stepData.showProductsSection:
                                        showOverlay(
                                            e,
                                            button,
                                            true,
                                            "showProductsSection"
                                        );
                                        break;
                                    case stepData.needRandomInsuranceCase:
                                        getRandomInsuranceCase(e, button, true);
                                        break;
                                    // case stepData.needUseInsurance:
                                    //     setUseInsurance(e, button, true);
                                    //     break;
                                    default:
                                        changeStep(
                                            e,
                                            button,
                                            stepData.isFinalDisplay
                                        );
                                }
                            }}
                        >
                            {button.buttonText}
                        </AppLink>
                    );
                }

                return (
                    <Button
                        key={button.buttonText}
                        theme={ButtonTheme.NEXT}
                        disabled={isDisabledButton}
                        className={classNames(
                            `${cls.furtherButton} ${cls.mb12}`,
                            {
                                [cls.moneyViewButton]:
                                    stepData.isMoneyViewButton,
                                [cls.finalDisplayButton]:
                                    stepData.isFinalDisplay,
                                [cls.nextMobButton]: button?.isMobButton,
                            }
                        )}
                        onClick={(e) => {
                            setIsDisabledButton(true);
                            switch (true) {
                                case stepData.needFinalSum:
                                    getFinalSum(e, button, true);
                                    break;
                                case stepData.needSetInsuranceCase:
                                    setInsuranceCase(e, button, true);
                                    break;
                                case stepData.needTransaction:
                                    setTransaction(e, button, true);
                                    break;
                                case stepData.needMonthPassed:
                                    setMonthPassed(e, button, true);
                                    break;
                                case button.needDoScam:
                                    deleteAllMoney(e, button, true);
                                    break;
                                case stepData.needCheckPolicy:
                                    checkPolicy(e, button, true);
                                    break;
                                case stepData.needRandomInsuranceCase:
                                    getRandomInsuranceCase(e, button, true);
                                    break;
                                case stepData.needUseInsurance:
                                    setUseInsurance(e, button, true);
                                    break;
                                case stepData.showShopSection:
                                    showOverlay(
                                        e,
                                        button,
                                        true,
                                        "showShopSection"
                                    );
                                    break;
                                case stepData.showProductsSection:
                                    showOverlay(
                                        e,
                                        button,
                                        true,
                                        "showProductsSection"
                                    );
                                    break;
                                case stepData.needSalary:
                                    getSalary(e, button, true);
                                    break;
                                case stepData.needAllMoney:
                                    getAllMoney(e, button, true);
                                    break;
                                default:
                                    changeStep(
                                        e,
                                        button,
                                        stepData.isFinalDisplay
                                    );
                            }
                        }}
                    >
                        {button.buttonText}
                    </Button>
                );
            })}
        </div>
    );
};
